// Build-time map of every logo file to its deployed URL, e.g.
// { "../../assets/logos/nec/act_tc.png": "/assets/act_tc-Dq16Bgq5.png" }
const LOGO_URLS = import.meta.glob<string>("../../assets/logos/*/*", {
  eager: true,
  import: "default",
});

// A file name ending in .png, .jpg or .jpeg (any case), up to 250 characters before the extension.
// Allows accents, spaces and punctuation (e.g. "Café Crème (1).png"); rejects path separators (/ \),
// control characters and characters that are invalid in file names (< > : " | ? *).
// eslint-disable-next-line no-control-regex -- control characters are deliberately rejected
export const LOGO_FILE_NAME = /^[^/\\\x00-\x1F\x7F<>:"|?*]{1,250}\.(?:png|jpe?g)$/i;

/**
 * resolve the merchant logo at `assets/logos/{participantId}/{logo}`, where `logo` is the file name
 * (with extension) from `options.logo`. It must match the committed file name exactly, including
 * case, e.g. "logo.PNG" only matches a file named "logo.PNG".
 * Returns undefined when there's no matching file — the page then shows no logo.
 */
export function resolveMerchantLogoUrl(participantId: string, logo: string): string | undefined {
  if (!LOGO_FILE_NAME.test(logo)) {
    return undefined;
  }
  const key = `../../assets/logos/${participantId}/${logo}`;
  return Object.hasOwn(LOGO_URLS, key) ? LOGO_URLS[key] : undefined;
}
